// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'satoshiFont', 'satoshiFont Fallback'"},"className":"__className_3982ee","variable":"__variable_3982ee"};